import { IToast } from 'interfaces/IToast';
import { IScript } from 'interfaces/script';
import { BehaviorSubject, Observable } from 'rxjs';
import * as rxjsOperators from 'rxjs-operators';

import { IProductNew } from '../interfaces/product';
import apiService, { ApiService } from './api';

//import { productService } from 'services/productService';
export class ToastService {
  private toastProduct = new BehaviorSubject<IScript[]>(null);
  private allToasts$ = new BehaviorSubject<any>(null);
  private selectedProduct$ = new BehaviorSubject<IProductNew>(null);

  constructor(private api: ApiService) {}

  public loadToastsProduct(id: number): Observable<any> {
    return this.api.get(`/toast/${id}`).pipe(
      rxjsOperators.take(1),
      rxjsOperators.tap(toasts => this.toastProduct.next(toasts))
    );
  }

  public loadAllToasts(): Observable<any> {
    return this.api.get(`/toast`).pipe(
      rxjsOperators.tap(allToasts => {
        this.allToasts$.next(allToasts);
      })
    );
  }

  public updateToast(toast: IToast): Observable<any> {
    return this.api.put(`/toast/${toast.id}`, toast).pipe(
      rxjsOperators.tap(toastProduct => this.toastProduct.next(toastProduct)),
      rxjsOperators.delay(1000),
      rxjsOperators.switchMap(() => this.loadAllToasts())
    );
  }

  public getToastsProduct() {
    return this.toastProduct.asObservable();
  }

  public getAllToasts() {
    return this.allToasts$.asObservable();
  }

  public setSelectedProduct(product: IProductNew) {
    if (product.toast) {
      this.loadToastsProduct(product.id);
    }
    this.selectedProduct$.next(product);
  }

  public getSelectedProduct() {
    return this.selectedProduct$.asObservable();
  }

  public unselectProduct() {
    this.selectedProduct$.next(null);
  }
}

export const ToastServiceFactory = () => new ToastService(apiService);

export const toastService = ToastServiceFactory();
